import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { JeevesProductTableComponent } from 'gung-standard-jeeves';
import { environment } from '../../../environments/environment';
import { PriceService, GungFlowService, AuthService, LocationConfigService } from 'gung-standard';

@Component({
    selector: 'ref-ref-jeeves-product-table',
    templateUrl: './ref-jeeves-product-table.component.html',
    styleUrls: ['./ref-jeeves-product-table.component.scss'],
    standalone: false
})
export class RefJeevesProductTableComponent extends JeevesProductTableComponent {
  isCapstone = environment.projectName === 'capstone';

  constructor(
    protected priceService: PriceService,
    protected gungFlowService: GungFlowService,
    protected authService: AuthService,
    protected router: Router,
    protected locationConfigService: LocationConfigService
  ) {
    super(priceService, gungFlowService, authService, router, locationConfigService);
  }
}
